<template>
  <div>
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="">{{ $t("banner.image") }}</label>
              <button
                type="button"
                class="btn btn-primary btn-xs pull-right"
                @click="onOpenInputSelectFile(imgList.length + 1)"
              >
                <span class="btn-label"> <i class="fa fa-plus"></i> </span>
                {{ $t("common.addnew") }}
              </button>
              <div :style="`overflow: auto; max-height: ${screenHight}px;`">
                <div
                  class="apartment-img-block"
                  v-if="imgList.length > 0"
                >
                  <div
                    v-for="(item, index) in imgList"
                    :key="item + index"
                  >
                    <img
                      id="apartment-img-id"
                      class="apartment-type-class img-responsive"
                      :src="item.url"
                      alt="apartment-img"
                    />
                    <div class="img-action">
                      <span
                        style="color: #006ad4"
                        class="action-button"
                        @click="onOpenInputSelectFile(index)"
                        ><small>{{ $t("common.update") }}</small></span
                      >
                      <span
                        style="color: #f2404d"
                        class="action-button"
                        @click="onclickRemoveImg(index)"
                        ><small>{{ $t("common.delete") }}</small></span
                      >
                    </div>
                  </div>
                </div>
                <div class="apartment-img-block" v-else>
                  <img
                    id="apartment-img-id"
                    class="apartment-type-class img-responsive"
                    :src="noImgDefault"
                    alt="apartment-img"
                  />
                </div>
              </div>
              <div style="padding-top: 6px; text-align: center">
                <input
                  class="img-upload-input"
                  :id="`upload-img-input`"
                  type="file"
                  accept="image/*"
                  @change="handleClick"
                />
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <label for="">{{ $t("homeMobileManagement.content") }}</label>
              <div>
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="13"
                  class="form-control"
                  v-model="homeMobileAppData.contentData"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer">
      <button type="button" class="btn btn-success pull-right" @click="onSave">
        {{ $t("common.save") }}
      </button>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import configuration from "@/lib/config";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import axios from "axios";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  data: () => ({
    isLoading: false,
    config: {
      // Get options from
      // https://alex-d.github.io/Trumbowyg/documentation
    },
    homeMobileAppData: {
      id: 0,
      contentData: null
    },

    screenHight: 0,
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
    imgUploadIndex: 0,
    imgList: [],
    imgUploadData: {
      url: null,
      size: null,
      file: null
    },
    media_server: {
      domain: "",
      token: ""
    }
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    },
    GET_PROJECT_EXTRA_INFO_DATA: function() {
      let data = this.GET_PROJECT_EXTRA_INFO_DATA
      this.homeMobileAppData.id =data.id
      this.homeMobileAppData.contentData = data.content
      this.imgList = !utils.isNull(data.img_list) ? data.img_list : []
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_TOKEN_UPLOAD_DATA",
      "GET_PROJECT_EXTRA_INFO_DATA"
    ])
  },
  methods: {
    handleResize() {
      this.screenHight =
        window.innerHeight - 325 > 300 ? window.innerHeight - 325 : 300;
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onclickRemoveImg: function(index) {
      this.imgList.splice(index, 1);
    },
    onOpenInputSelectFile: function(index) {
      this.imgUploadIndex = index;
      $(`#upload-img-input`).val("");
      $(`#upload-img-input`).click();
    },
    addAndUpdateImgList: function() {
      if (this.imgUploadIndex > this.imgList.length) {
        let item = {
          url: this.imgUploadData.url
        };
        this.imgList.push(item);
      } else {
        let imgListElement = this.imgList[this.imgUploadIndex];
        imgListElement.url = this.imgUploadData.url;
      }
      // if (this.imgUploadIndex > this.imgList.length) {
      //   // let item = {
      //   //   id: 0,
      //   //   url: this.imgUploadData.url
      //   // };
      //   this.imgList.push(this.imgUploadData.url);
      // } else {
      //   // let imgListElement = this.imgList[this.imgUploadIndex];
      //   this.imgList[this.imgUploadIndex] = this.imgUploadData.url;
      // }
    },
    // handle upload img
    handleClick: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgUploadData.size = files[0].size;
      await this.uploadImgFunction();
      await this.addAndUpdateImgList();
    },
    getResultFile: function(file) {
      let vm = this;
      vm.imgUploadData.file = file;
    },
    uploadImgFunction: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.imgUploadData.file);
        formData.append("directory", "homeMobileApp");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              this.imgUploadData.url = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onSave: function() {
      if (utils.isEmptyString(this.homeMobileAppData.contentData)) {
        this.onShowError(this.$t("homeMobileManagement.content"));
      } else if (this.imgList.length === 0) {
        this.onShowError(this.$t("banner.image"));
      } else {
        let data = {
          id: this.homeMobileAppData.id,
          projectExtraContent: this.homeMobileAppData.contentData,
          imgList: this.imgList
        };
        this.POST_PROJECT_EXTRA_INFO(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "POST_PROJECT_EXTRA_INFO",
      "GET_PROJECT_EXTRA_INFO"
    ])
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.GET_PROJECT_EXTRA_INFO();
  }
};
</script>
<style scoped>
.img-upload-input {
  display: none;
  z-index: -9999;
}
/* .apartment-type-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
  padding: 5px;
} */

.apartment-type-class {
  margin: auto;
  /* width: 100%; */
  width: 200px;
  height: 200px;
  object-fit: contain;
  padding: 10px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 3%;
}

.apartment-img-block {
  display: inline-block;
  margin-bottom: 15px;
}
.img-action {
  justify-content: space-between;
  display: flex;
  margin: 0 5px;
  padding: 0 5px;
}

.action-button:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeMobileManagement/InformationTab.vue